export default function() {
  if (process.client) {
    document.addEventListener('click', (event) => {
      const clickedEl = event.target

      if (!clickedEl || clickedEl === document.body) return

      if( clickedEl.tagName === 'DIV' && !clickedEl.hasAttribute('tabindex')) {

        clickedEl.setAttribute('tabindex', '-1')
        clickedEl.focus()

        // Cleanup tabindex after blur
        clickedEl.addEventListener('blur', () => {
          clickedEl.removeAttribute('tabindex')
        }, { once: true })
      }
    })
  }
}
